

















































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import PermissionTree from '../../../components/permissionTree.vue'
import AbpBase from '../../../lib/abpbase'
import Role from '@/store/entities/role'

@Component({
    components: { PermissionTree }
})
export default class EditRole extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Array}) roleTypes:any;
    @Prop({type:Array}) tree:any;
    role:Role=new Role();
    selectPermissions:any[];
    get permissions(){
        return this.$store.state.role.permissions
    }
    save(){
        // this.$emit('savemenu',(this.$refs.perTree as any).getCheckedNodes())
        (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                let copyRole = JSON.parse(JSON.stringify(this.role))
                if (this.selectPermissions && this.selectPermissions.length >= 0) {
                    copyRole.permissions = this.selectPermissions
                }
                copyRole.allowLowEdit = Boolean(copyRole.allowLowEdit)
                await this.$store.dispatch({
                    type:'role/update',
                    data:copyRole
                });
                (this.$refs.roleForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
                this.$emit('savemenu',(this.$refs.perTree as any).getCheckedNodes())
            }
        })
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }else{
            if(this.$store.state.role.editRole.allowLowEdit){
                this.$store.state.role.editRole.allowLowEdit = String(this.$store.state.role.editRole.allowLowEdit)
            }else{
                this.$store.state.role.editRole.allowLowEdit = 0
            }
            
            this.role=Util.extend(true,{},this.$store.state.role.editRole);
            // this.role.allowLowEdit = String(this.role.allowLowEdit)
        }
    }
    checkChange(value:any[]) {
        this.selectPermissions = value
    }
    roleRule={
        name:[{required: true,message:'角色名称不能为空',trigger: 'blur'}],
        displayName:[{required:true,message:'显示名称不能为空',trigger: 'blur'}]
    }
    
}
